import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

export type Props = {
    className?: string;
    children?: JSX.Element;
    link: string;
    ignoreNestedPreviews?: boolean;
    onClick?: () => void;
};
const PostAttachmentContainer = (props: Props) => {
    const {children, className, link, ignoreNestedPreviews} = props;
    const history = useHistory();
    const handleOnClick = useCallback((e) => {
        props.onClick?.();
        e.stopPropagation();

        if (ignoreNestedPreviews) {
            history.push(link);
            return;
        }

        const {tagName} = e.target;
        const elements = ['A', 'IMG', 'BUTTON', 'I'];

        if (!elements.includes(tagName) && (e.target.getAttribute('role') !== 'button' && e.target.className !== `attachment attachment--${className}`)) {
            const classNames = ['icon icon-menu-down', 'icon icon-menu-right', 'post-image', 'file-icon'];

            if (!classNames.some((className) => e.target.className?.includes?.(className)) && e.target.id !== 'image-name-text') {
                history.push(link);
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);
    return (
        <div
            className={`attachment attachment--${className}`}
            role={'button'}
            onClick={handleOnClick}
        >
            <div className={`attachment__content attachment__content--${className}`}>
                <div className={`clearfix attachment__container attachment__container--${className}`}>
                    <div className={`attachment__body__wrap attachment__body__wrap--${className}`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostAttachmentContainer;
